module.exports = __webpack_public_path__ + "img/setsplit.e2dac999.svg";